export default "__VITE_ASSET__BjPNCztI__"